export default __webpack_public_path__ + "static/media/small white bottle.3d380afb.jpeg";